import styled from "styled-components";

export const ProductListContainer = styled.div`
  max-width: 1100px;
  margin: 2rem auto;
  padding: 2rem;
`;
